import { siteApiSlice } from "../../app/siteApiSlice";
import NamedEntity from "../../interfaces/NamedEntity";

export interface GetSchoolsRequestModel {
	districtCode: string;
}

export const districtsApiSlice = siteApiSlice
	.enhanceEndpoints({
		addTagTypes: ["Districts"],
	})
	.injectEndpoints({
		endpoints: (build) => ({
			getSchools: build.mutation<NamedEntity[], GetSchoolsRequestModel>({
				query: (payload) => ({
					url: `/District/GetSchools`,
					method: "POST",
					body: payload,
				}),
			}),
		}),
	});

export const { useGetSchoolsMutation } = districtsApiSlice;
